// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"FakeRow_loaderWrapper__2aSOZ","message":"FakeRow_message__2ZosA","errorMsg":"FakeRow_errorMsg__2ciIu"};